<template>
  <button-block
      @click="history_back"
      :btnClass='btnClass'
      :text='text'
      :textIcon="textIcon"
      :sm="sm"
      :disabled="disabled"
      :icon="icon"
  />
</template>

<script>
import ButtonBlock from "./ButtonBlock";

export default {
  components: {ButtonBlock},
  data: function () {
    return {}
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn-secondary',
    },
    text: {
      type: String,
      default: 'Отмена',
    },
    textIcon: {
      type: String,
      default: 'fas fa-backward',
    },
    sm: Boolean,
    disabled: Boolean,
    icon: Boolean,
  },
  computed: {},
  mounted() {

  },
  methods: {}
}
</script>
